/** `Documents`-Menü aus `IwmViewContainer`/`IwmViewRechnungen` samt `OnDokumentClick`. */

import { DropDownButton } from '@/components/ui';
import type { DropDownItem } from '@/components/ui/types';

const ITEMS: DropDownItem[] = [
  { id: 'Upload', text: 'Upload Document' },
  { id: 'List', text: 'List Documents' },
];

export interface DocumentsDropDownProps {
  /** Ohne ausgewählten Datensatz ist das Menü gesperrt. */
  selectedId: number | null;
  onUpload(): void;
  onList(): void;
}

export function DocumentsDropDown(props: DocumentsDropDownProps) {
  return (
    <DropDownButton
      content="Documents"
      disabled={props.selectedId === null}
      items={ITEMS}
      onItemSelected={(item) => {
        // Port von `OnDokumentClick`.
        switch (item.id) {
          case 'Upload':
            props.onUpload();
            break;
          case 'List':
            props.onList();
            break;
        }
      }}
    />
  );
}

export default DocumentsDropDown;
